export enum EHitZones {
HEAD = "head",
BODY = "body",
LEGS = "legs",
}
